import { render, staticRenderFns } from "./LabelComponent.vue?vue&type=template&id=6c2b1b88&scoped=true&"
import script from "./LabelComponent.vue?vue&type=script&lang=js&"
export * from "./LabelComponent.vue?vue&type=script&lang=js&"
import style0 from "./LabelComponent.vue?vue&type=style&index=0&id=6c2b1b88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2b1b88",
  null
  
)

export default component.exports